const SidePanelType = {
  participants: 'participants',
  chat: 'chat',
  notes: 'notes',
};

export default SidePanelType;
